import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import CancelButton from '../../../../../../components/buttons/CancelButton'
import PrimaryButton from '../../../../../../components/buttons/PrimaryButton'
import CloseIcon from '@material-ui/icons/Close'
import TextField from '@material-ui/core/TextField'

const useStyles = makeStyles((theme) => ({
  titleSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: '32px 32px 0px 32px',
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  closeBtn: {
    cursor: 'pointer',
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#404040',
  },
  subTitle: {
    fontSize: 14,
    color: '#404040',
    marginTop: 16,
  },
  contentSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: '28px 32px 0px 32px',
  },
  footerSection: {
    padding: '28px 32px  26px',
  },
}))

export default (props) => {
  const { fullName, editNote, note, openOrCloseEditDialog } = props
  const styleClass = useStyles()
  const { formatMessage } = useIntl()

  const [localState, setLocalState] = useState({
    isDisabledBtn: true,
    text: note.text,
  })

  const handleEdit = () => {
    editNote({ noteId: note.id, text: localState.text })
    setLocalState({
      ...localState,
      isDisabledBtn: true,
    })
  }

  const handleTextOnChange = ({ target }) => {
    let text = target.value
    const isEmpty = !text.trim()
    setLocalState({
      ...localState,
      isDisabledBtn: isEmpty,
      text,
    })
  }

  return (
    <Dialog
      maxWidth="sm"
      fullWidth={true}
      className={styleClass.dialogWrapper}
      open={true}
    >
      <DialogTitle disableTypography={true} className={styleClass.titleSection}>
        <div className={styleClass.titleWrapper}>
          <div className={styleClass.title}>
            <FormattedMessage id="note.edit.title" values={{ fullName }} />
          </div>
          <div
            className={styleClass.closeBtn}
            onClick={() => openOrCloseEditDialog()}
          >
            <CloseIcon />
          </div>
        </div>
        <div className={styleClass.subTitle}>
          <FormattedMessage id="note.edit.subtitle" values={{ fullName }} />
        </div>
      </DialogTitle>

      <DialogContent className={styleClass.contentSection}>
        <TextField
          label={formatMessage({ id: 'note.edit.editNote.label' })}
          variant="outlined"
          onChange={handleTextOnChange}
          value={localState.text}
        />
      </DialogContent>

      <DialogActions className={styleClass.footerSection}>
        <CancelButton
          className={styleClass.actionBtn}
          onClick={() => openOrCloseEditDialog()}
        >
          <FormattedMessage id="action.cancel" />
        </CancelButton>

        <PrimaryButton
          disabled={localState.isDisabledBtn}
          onClick={handleEdit}
          className={styleClass.actionBtn}
        >
          <FormattedMessage id="action.update" />
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  )
}
